import React from 'react';
import { Checkbox } from 'antd';

const CheckboxTask = ({ value, onChange, label }) => (
  <Checkbox checked={value} onChange={onChange} >{label}</Checkbox>
);
export default CheckboxTask;
